module.exports = __webpack_public_path__ + "static/img/siderbar_bg.941390e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/siderbar_bg.png
// module id = L2/O
// module chunks = 37